module.exports = __webpack_public_path__ + "media/eat8.7264ec82.mp4";